import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../../axiosAuth";
import { PROPERTY_ZONE } from "./apiRoutes";

interface mutateProps {
  communityId: string;
  id: string;
}

const mutateDeletePropertyZone = async ({ id, communityId }: mutateProps) => {
  return await axiosAuth.delete(`${PROPERTY_ZONE(communityId)}/${id}`);
};

const useDeletePropertyZoneMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateDeletePropertyZone,
    ...queryParams,
  });

export default useDeletePropertyZoneMutation;
